// extracted by mini-css-extract-plugin
export default {"FacetHelp":"yk_a big_jj big_ta","FacetHelp__paragraph":"yk_b big_vt big_xg","FacetHelp__youtube":"yk_c"};